<template>
  <div class="main">
    <Result
      :icon="getIcon('img/credit-line/success_cc.svg')"
      :error="!successResult"
      :title="title"
      :description="description"
      :btnText="btnText"
      @dismissFunc="dismiss()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Result from "@/apps/credit-line/components/Result.vue";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { useRouter } from "vue-router";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
declare const Android: AndroidInterface;
export default defineComponent({
  name: "CreditCardPinChangeResultView",
  components: {
    Result,
  },
  beforeMount() {
    setLanguage(this);
  },
  methods: {
    getIcon(path: string): string {
      return useAsset(path);
    },
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const successResult = ref<boolean>();
    const title = ref<string>();
    const description = ref<string>();
    const btnText = ref<string>();
    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      successResult.value = urlParams.get("success") === "1";
    });

    watch(successResult, (newValue) => {
      if (newValue) {
        title.value = t("PAYJOY_CARD_VIEWS.PIN_CHANGE_RESULT_SUCCESS_TITLE");
        description.value = t(
          "PAYJOY_CARD_VIEWS.PIN_CHANGE_RESULT_SUCCESS_DESCRIPTION"
        );
        btnText.value = t("PAYJOY_CARD_VIEWS.PIN_CHANGE_RESULT_SUCCESS_BTN");
      } else {
        title.value = t("PAYJOY_CARD_VIEWS.PIN_CHANGE_RESULT_ERROR_TITLE");
        description.value = t(
          "PAYJOY_CARD_VIEWS.PIN_CHANGE_RESULT_ERROR_DESCRIPTION"
        );
        btnText.value = t("PAYJOY_CARD_VIEWS.PIN_CHANGE_RESULT_ERROR_BTN");
      }
    });

    const dismiss = () => {
      if (successResult.value) {
        router.push({ name: "CreditCardDetailsView" });
      } else {
        Android.dismissWebView();
      }
    };

    return {
      title,
      btnText,
      description,
      successResult,
      dismiss,
    };
  },
});
</script>

<style lang="scss" scoped></style>
